module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/step-4-70de1527fe4bf98089859e8600d77f78.png";